import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MediaListItem from './media-list-item-model'
import {
  CreateMediaListItemAsync,
  DeleteMediaListItemAsync,
  LoadMediaListItemsAsync,
} from './mediaListItem-thunk'
const initialState: mediaListItemSliceState = {
  mediaListItem: [],
  selected_mediaListItem: '',
  is_loading_mediaListItem: false,
  is_creating_mediaListItem: false,
  is_deleting_mediaListItem: false,
}
export interface mediaListItemSliceState {
  mediaListItem: MediaListItem[]
  selected_mediaListItem?: string
  is_loading_mediaListItem: boolean
  is_creating_mediaListItem: boolean
  is_deleting_mediaListItem: boolean
}
export const mediaListItemSlice = createSlice({
  name: 'mediaListItem',
  initialState,
  reducers: {
    setSelectedmediaListItem: (state, action) => {
      state.selected_mediaListItem = action.payload
    },
    clearStatemediaListItem: (state) => {
      state.mediaListItem = []
      state.is_loading_mediaListItem = false
      state.is_creating_mediaListItem = false
      state.is_deleting_mediaListItem = false
    },
    mergemediaListItem: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediaListItem = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediaListItem = merge(state.mediaListItem, payload) as any
        }
      }
    },

    add_mediaListItem: (state, action) => {
      if (action.payload) {
        state.mediaListItem = [...state.mediaListItem, action.payload]
      }
    },
    set_mediaListItem: (state, action) => {
      let { key, value, id } = action.payload
      state.mediaListItem = state.mediaListItem.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediaListItemsAsync.pending, (state) => {
      state.is_loading_mediaListItem = true
    })
    builder.addCase(LoadMediaListItemsAsync.fulfilled, (state, action) => {
      state.is_loading_mediaListItem = false
      if (action.payload) {
        state.mediaListItem = action.payload
      }
    })
    builder.addCase(LoadMediaListItemsAsync.rejected, (state) => {
      state.is_loading_mediaListItem = false
    })
    builder.addCase(CreateMediaListItemAsync.pending, (state) => {
      state.is_creating_mediaListItem = true
    })
    builder.addCase(CreateMediaListItemAsync.fulfilled, (state) => {
      state.is_creating_mediaListItem = false
    })
    builder.addCase(CreateMediaListItemAsync.rejected, (state) => {
      state.is_creating_mediaListItem = false
    })
    builder.addCase(DeleteMediaListItemAsync.pending, (state) => {
      state.is_deleting_mediaListItem = true
    })
    builder.addCase(DeleteMediaListItemAsync.fulfilled, (state, action) => {
      state.is_deleting_mediaListItem = false
      if (state.mediaListItem) {
        state.mediaListItem = state.mediaListItem.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMediaListItemAsync.rejected, (state) => {
      state.is_deleting_mediaListItem = false
    })
  },
})

export const {
  clearStatemediaListItem,
  setSelectedmediaListItem,
  set_mediaListItem,
  mergemediaListItem,
  add_mediaListItem,
} = mediaListItemSlice.actions

export const get_mediaListItem =
  (id?: string) =>
  (state: {
    mediaListItem: {
      mediaListItem: MediaListItem[]
    }
  }): MediaListItem | null => {
    let temp = state?.mediaListItem?.mediaListItem?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.mediaListItem?.mediaListItem[0] || null
  }
export const get_selected_mediaListItem = (state: {
  mediaListItem: mediaListItemSliceState
}): MediaListItem | null => {
  let id = state?.mediaListItem?.selected_mediaListItem
  let temp = state?.mediaListItem?.mediaListItem?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediaListItem = (state: {
  mediaListItem: {
    mediaListItem: MediaListItem[]
  }
}): MediaListItem[] => {
  let temp = state?.mediaListItem?.mediaListItem
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediaListItem_busy = (state: {
  mediaListItem: mediaListItemSliceState
}) => {
  return (
    state?.mediaListItem.is_deleting_mediaListItem ||
    state?.mediaListItem.is_loading_mediaListItem ||
    state?.mediaListItem.is_creating_mediaListItem
  )
}
export const is_deleting_mediaListItem_busy = (state: {
  mediaListItem: mediaListItemSliceState
}) => {
  return state?.mediaListItem.is_deleting_mediaListItem
}
export const is_loading_mediaListItem_busy = (state: {
  mediaListItem: mediaListItemSliceState
}) => {
  return state?.mediaListItem.is_loading_mediaListItem
}
export const is_creating_mediaListItem_busy = (state: {
  mediaListItem: mediaListItemSliceState
}) => {
  return state?.mediaListItem.is_creating_mediaListItem
}

export default mediaListItemSlice.reducer
